import { makeAutoObservable } from 'mobx'
import StoreReferralFormat from './StoreReferralFormat'
import { get } from 'lodash'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import storeUser from 'GlobalStores/User/StoreUser'
import storeReferral from './StoreReferral'
import storeReferralCheckout from './StoreReferralCheckout'
import storeCheckout from 'GlobalStores/Checkout/StoreCheckout'
import { findOosItems, optionPrice, resolvePriceOption, sessionItemsFrom } from '../Helpers/addonHelpers'

class storeReferralCart {
    isProductPage = false
    items = []

    totalPrice = 0
    shippingPriceWithoutMethod = 0

    overseasShippingLimit = (countryName) => {

        switch (countryName) {
            case 'Kuwait':
                return 3
            case 'Qatar':
                return 3
            case 'Saudi Arabia':
                return 3
            case 'United Arab Emirates':
                return 3
            default:
                return 3
        }
    }

    showWarningNFRQtyLimitModal = false

    increaseQty(id, qty = 1) {

        const selectItem = this.items.find(item => item.id === id)

        if (!selectItem) {
            return
        }

        const isAddon = selectItem.isAddon === true
        const overseasShippingLimit = this.GetOverseasShippingLimit(storeReferralCheckout.GetCurrentAddressCountry())

        const qty_sellable = get(this.SelectedOption(selectItem), 'qty')

        this.items = this.items.map(item => {
            if (item.id === id) {

                if (item.qty >= qty_sellable) {
                    return item
                }
                const itemQty = item.qty

                if (!isAddon && (itemQty >= overseasShippingLimit) && overseasShippingLimit) {

                    if (this.isProductPage === false) {
                        this.SetShowWarningNFRQtyModal(true)
                    }

                    item.qty = overseasShippingLimit
                    return item
                }

                if (itemQty === qty_sellable) {
                    return item
                }

                if (item.qty >= 0) {
                    item.qty += qty
                }
            }

            return item
        })
    }

    decreaseQty(id, qty = 1) {
        const selectItem = this.items.find(item => item.id === id)

        if (!selectItem) {
            return
        }

        const isSingle = selectItem.type === 'single' || selectItem.isAddon === true
        const qty_sellable = get(this.SelectedOption(selectItem), 'qty')
        const itemsToRemove = []
        this.items = this.items.map(item => {
            if (item.id === id) {
                if (qty_sellable === 0) {
                    return item
                }
                if (item.qty > 1) {
                    item.qty -= qty
                } else {
                    if (isSingle) {
                        if (item.qty > 0) {
                            item.qty -= qty
                        }
                    }
                }
                if (item.qty === 0) {
                    itemsToRemove.push(item.id)
                }
            }

            return item
        })

        itemsToRemove.forEach(id => {
            this.removeItem(id)
        })
    }

    assignQty(id, qty = 1) {
        const overseasShippingLimit = this.GetOverseasShippingLimit(storeReferralCheckout.GetCurrentAddressCountry())

        this.items = this.items.map(item => {
            const qty_sellable = get(this.SelectedOption(item), 'qty')

            if (item.id === id) {
                if (item.isAddon !== true && qty > overseasShippingLimit && overseasShippingLimit) {
                    // AddressCountryCartLimit more precedence than qty_sellable
                    item.qty = overseasShippingLimit

                    if (this.isProductPage === false) {
                        this.SetShowWarningNFRQtyModal(true)
                    }


                } else if (qty > qty_sellable) {
                    item.qty = qty_sellable
                } else {
                    item.qty = qty
                }
            }

            return item
        })

    }

    removeItem(id) {
        this.items = this.items.filter(item => item.id.toString() !== id.toString())
    }

    addItem(item) {
        this.items.push(item)
    }

    addItemAndAssignQty(item, qty = 1) {
        if (this.items.find(cartItem => cartItem.id === item.id)) {
            this.assignQty(item.id, qty)
        } else {
            this.addItem(item)
            this.assignQty(item.id, qty)
        }
    }

    clearCart() {
        this.items = []
    }

    ReplaceItems(rows) {
        this.items = (Array.isArray(rows) ? rows : []).map(row => ({ ...row }))
    }

    // Counts pack units. The argument used to be `noBottle`, where `true` meant *exclude* — the opposite
    // of what it means now — so no caller passes it any more; add-ons are only counted on request.
    getTotalItems(includeAddons = false) {
        let total = 0
        this.items.forEach(item => {
            if (!includeAddons && item.isAddon) {
                return
            }
            total += item.qty
        })
        return total
    }

    SelectedOption(item) {
        return resolvePriceOption(item, StoreReferralFormat.paymentOptionSelected)
    }

    PriceKey() {
        return this.hasDiscount() ? 'member' : 'retail'
    }

    UnitPrice(item) {
        return optionPrice(this.SelectedOption(item), this.PriceKey())
    }

    getTotalPrice() {
        let total = 0

        this.items.forEach(item => {
            total += this.UnitPrice(item) * item.qty
        })

        return total
    }

    TotalPriceIncludeShipping(countryValue) {
        let total = 0

        this.shippingPriceWithoutMethod = storeCheckout.CheckOutInstance().Instance().SpecialAreasDeliveryFeeCondition(countryValue)

        this.items.forEach(item => {
            total += this.UnitPrice(item) * item.qty
        })

        return total + this.shippingPriceWithoutMethod
    }

    GetShippingPriceWithoutMethod() {
        return this.shippingPriceWithoutMethod
    }

    getCartItems() {
        return sessionItemsFrom(this.items, StoreReferralFormat.paymentOptionSelected)
    }

    GetPackItems() {
        return this.items.filter(item => item.isAddon !== true)
    }

    GetAddonItems() {
        return this.items.filter(item => item.isAddon === true)
    }

    HasPack() {
        return this.GetPackItems().some(item => item.qty > 0)
    }

    getTotalPV() {
        let total = 0

        this.items.forEach(item => {
            total += get(this.SelectedOption(item), 'pv', 0) * item.qty
        })
        return total
    }

    hasDiscount() {
        const statusAllow = storeCountry.GetAllowDiscountStatus()
        const baStatus = storeUser.GetBaStatus()
        //const hasReferral = false

        // TODO:
        const hasReferral = storeReferral.HasReferral()

        if (statusAllow.includes(baStatus) || (hasReferral && baStatus !== 'C')) {
            return true
        }
        return false
    }

    TotalQty() {
        let total = 0
        this.items.forEach(item => {
            total += item.qty
        })
        return total
    }

    GetOverseasShippingLimit = country => {
        return this.overseasShippingLimit(country)
    }

    SetShowWarningNFRQtyModal = val => {
        this.showWarningNFRQtyLimitModal = val
    }

    IsShowWarningNFRQtyModal = () => {
        return this.showWarningNFRQtyLimitModal
    }

    ResetAllItemQtytoOne = () => {
        this.items = this.items.map(item => {
            const product = this.SelectedOption(item)
            item.qty = product && product.qty === 0 ? 0 : 1

            return item
        })
    }

    ResetAfterSuccessfulOrder = () => {
        this.items = this.GetPackItems()
        this.ResetAllItemQtytoOne()
    }

    // Same test as the one Place order runs (storeReferralCheckout.CheckOutofStockCartItems), so the
    // button can never look ready for a cart the order path will reject. The old version only compared
    // qty to 0, which missed a row tagged out_of_stock while still holding stock, and a row whose
    // option is missing altogether.
    //
    // Rows at qty 0 are skipped: nobody is ordering them, they are hidden from the summary (which
    // filters qty > 0), and ResetAllItemQtytoOne parks a sold-out pack at 0 on purpose — leaving them in
    // blocked Place order over a row the customer could not see or remove.
    IsSoldOut() {
        return findOosItems(this.OrderableItems(), StoreReferralFormat.paymentOptionSelected).length > 0
    }

    OrderableItems() {
        return this.items.filter(item => (Number(item.qty) || 0) > 0)
    }

    constructor() {
        makeAutoObservable(this)
    }
}
const StoreReferralCart = new storeReferralCart()
export default StoreReferralCart
